export default "__VITE_ASSET__ac790c56__"